"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = require("js-cookie");
exports.default = {
    get: function (cookieName) {
        return js_cookie_1.get(cookieName);
    },
    set: function (cookieName, value, expiresDays) {
        var opts = {};
        if (expiresDays) {
            opts.expires = expiresDays;
        }
        return js_cookie_1.set(cookieName, value, opts);
    },
    remove: function (cookieName) {
        return js_cookie_1.remove(cookieName);
    },
};
//# sourceMappingURL=reverb_cookie.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/reverb_cookie.js
// module id = bTKM
// module chunks = 20 21 22